import { Navigate } from 'react-router-dom'
import { useUserContext } from '../context/users/UserContext'
 
const AuthenticatedRoute = ({ children }) => {
    const { isAuthenticated, authenticatedUser, loading } = useUserContext()
    
    // Mostrar loading mientras se verifica la autenticación
    if (loading) {
      return (
        <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Cargando...</span>
          </div>
        </div>
      )
    }
 
    if (isAuthenticated && authenticatedUser) {
      if (authenticatedUser.pendingPlan) {
        return <Navigate to='/seleccionaPlan' replace />
      }
      return children
    } 

    return <Navigate to='/login' replace />
}
 
export default AuthenticatedRoute
